import { Box, styled } from '@mui/material';
import { Editor } from '@tiptap/react';
import { Suspense, forwardRef, lazy } from 'react';
import { TableHandles } from '../private/TableHandles';
import { EditorStyles } from './EditorStyles';

// Lazy load do EditorBubbleMenu para evitar dependência circular
const LazyEditorBubbleMenu = lazy(() =>
  import('../private/components/EditorBubbleMenu').then((module) => ({
    default: module.EditorBubbleMenu,
  })),
);

export const BoxStyled = styled(Box)(() => ({
  width: '100%',
  position: 'relative',

  '& .ProseMirror': {
    outline: 'none',
  },
  '&  p.is-editor-empty:first-of-type::before, & :where(p, h1, h2, h3, h4, h5, h6).is-empty::before':
    {
      content: 'attr(data-placeholder)',
      float: 'left',
      color: 'var(--theme-color-stone-400)',
      pointerEvents: 'none',
      height: 0,
    },
}));

type Props = React.HTMLProps<HTMLDivElement> & {
  editor: Editor | null;
};

export const EditorContainer = forwardRef(
  ({ children, editor, as: _, ...other }: Props, ref: any) => {
    return (
      <BoxStyled data-editor-container ref={ref} {...other}>
        <EditorStyles>
          {editor && (
            <Suspense fallback={null}>
              <LazyEditorBubbleMenu editor={editor} />
            </Suspense>
          )}
          {children}
          {editor && <TableHandles editor={editor} />}
        </EditorStyles>
      </BoxStyled>
    );
  },
);
